var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWebsite(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Computer",
    clipPath: "url(#clip0_8673_1593)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M17.1765 0.658691H4.69759C2.17505 0.658691 0.130127 2.70361 0.130127 5.22615V17.705C0.130127 20.2276 2.17505 22.2725 4.69759 22.2725H17.1765C19.699 22.2725 21.7439 20.2276 21.7439 17.705V5.22615C21.7439 2.70361 19.699 0.658691 17.1765 0.658691Z",
    fill: "url(#paint0_linear_8673_1593)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Vector_2",
    filter: "url(#filter0_d_8673_1593)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.07813 5.64648C6.55839 5.64674 6.06001 5.85331 5.6925 6.22082C5.32499 6.58834 5.11842 7.08671 5.11816 7.60645V14.1372C5.11816 15.2193 5.99697 16.0971 7.07813 16.0971H11.6419L9.86845 17.0472H8.9184V17.9972H14.6187V17.0472H13.6687V16.0971H16.46C16.9795 16.0964 17.4774 15.8896 17.8447 15.5222C18.2119 15.1547 18.4185 14.6567 18.419 14.1372V7.6055C18.4182 7.08601 18.2115 6.58802 17.844 6.22077C17.4766 5.85351 16.9785 5.64699 16.459 5.64648H7.07813ZM7.07813 6.59654H16.459C17.0157 6.59654 17.4689 7.04877 17.4689 7.60645V14.1372C17.4689 14.6939 17.0157 15.1471 16.459 15.1471H7.07813C6.81037 15.1468 6.55364 15.0403 6.3643 14.851C6.17496 14.6617 6.06847 14.4049 6.06822 14.1372V7.6055C6.06822 7.04972 6.52045 6.59654 7.07813 6.59654ZM10.8185 16.0971H12.7186V17.0472H10.8185V16.0971Z",
    fill: "white"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_8673_1593",
    x: 5.11816,
    y: 5.64648,
    width: 26.6016,
    height: 25.6514,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 6.65041,
    dy: 6.65041
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 3.3252
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_8673_1593"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_8673_1593",
    result: "shape"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_8673_1593",
    x1: 21.7439,
    y1: 11.4656,
    x2: 0.130127,
    y2: 11.4656,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7021F1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#41138B"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8673_1593"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 21.6138,
    height: 21.6138,
    fill: "white",
    transform: "translate(0.130127 0.658691)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWebsite);
export default __webpack_public_path__ + "static/media/website.b3e2cc73b1452fd8fef94ed3e0a1f945.svg";
export { ForwardRef as ReactComponent };